export default {
  namespaced: true,
  state: {
    documentSettings:null
  },
  mutations: {
    SET_STATE: (state, payload) => {
      state.documentSettings = payload;
    },
  },
  getters: {
    STATE: (state) => {
      return state.documentSettings;
    },
  },
};
